import { Alert, AlertDescription, AlertIcon, Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionDto, SupplierInformationDto } from "../../../../autogen/bff-api";
import { AnnouncementCard } from "../../../../common/components/communication/AnnouncementCard";

export const PublicFeedPreview = ({
  eventId,
  announcements,
  questionsByInformationId = new Map(),
}: {
  eventId: string;
  announcements: SupplierInformationDto[];
  questionsByInformationId?: Map<string, SeV2QuestionDto[]>;
}) => {
  const { t } = useTranslation();

  if (announcements.length === 0) {
    return (
      <Box py="10" textAlign="center" color="smMuted">
        <Text>{t("Nothing published to tenderers yet")}</Text>
      </Box>
    );
  }

  return (
    <Stack spacing="4">
      <Alert status="info" rounded="md" fontSize="sm">
        <AlertIcon />
        <AlertDescription>{t("This is what tenderers see. Make sure questions are anonymized.")}</AlertDescription>
      </Alert>
      {announcements.map((announcement) => (
        <AnnouncementCard
          key={announcement.id}
          eventId={eventId}
          announcement={announcement}
          originatingQuestions={questionsByInformationId.get(announcement.id)}
        />
      ))}
    </Stack>
  );
};
